module.exports = __webpack_public_path__ + "img/1.962dd6c2.png";